import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useNavigate } from "react-router-dom";
import { useCentralStore } from "stores";

export const updateRole = ({
  churchId,
  isDenomination = false,
  denominationId,
  roleId,
  roleData
}) => {
  return axios.put(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/roles/${roleId}`,
    roleData
  );
};

export const useUpdateRole = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const navigate = useNavigate();

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("roles");

      setNotification({
        type: "success",
        message: "Role updated successfully!"
      });

      navigate("/users");
    },
    ...config,
    mutationFn: updateRole
  });
};
